(function () {
    'use strict';

    angular.module('ib-pmt-total-price-module', ['ib-pmt-paypal-afop-button-module', 'ib-pmt-dcc-module']);
})();
